import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { overlayChannel } from 'src/channels/overlay.channel';
import FadeInContainer from '../../container/FadeInContainer';
import styles from './OverlayFixedBg.module.scss';
import { EOverlayContentWidth, POSITIONS } from './types';

interface IOverlayFixedBgProps {
  closeBg: () => void;
  position?: POSITIONS;
  children: React.ReactNode;
  isBgTransparent?: boolean;
  paddingTop?: string;
  order?: number;
  isFade?: boolean;
  backgroundFitContent?: boolean; //remove dark bg and add ability to click outside of overlay
  enableScroll?: boolean;
  contentWidth: EOverlayContentWidth;
  isNotification?: boolean;
  isV3?: boolean;
  // add blur bg for lucky wheel
  blurBgWheel?: boolean;
  withBoxShadow?: boolean;
}

const OverlayFixedBg = ({
  order: _order,
  closeBg,
  enableScroll,
  position,
  isFade,
  backgroundFitContent,
  isNotification,
  paddingTop,
  isV3,
  contentWidth,
  children,
  isBgTransparent,
  blurBgWheel,
  withBoxShadow,
}: IOverlayFixedBgProps) => {
  const [order] = useState((_order ?? 0) + 1);

  useEffect(() => {
    // Disable scroll
    const isFirstOverlay = order <= 1;

    if (isFirstOverlay && !enableScroll) {
      document.body.classList.add('disable-scroll');
      // document.body.style.position = 'fixed';
      // document.body.style.top = `-${window.scrollY}px`;
      // document.body.style.width = '100%';
    }

    // broadcast our existance
    overlayChannel.send({
      overlayOrder: order,
      action: 'DISPLAY',
    });

    return () => {
      // Enable scroll
      if (order <= 1) {
        document.body.classList.remove('disable-scroll');
        document.body.style.position = 'unset';
        document.body.style.top = 'unset';

        // Restore scroll position
        window.scrollTo(0, window.scrollY);
      }

      overlayChannel.send({
        overlayOrder: order,
        action: 'CLOSE',
      });
    };
  }, []);

  return (
    <div
      className={classNames(styles.bg_shadow_main, {
        [styles.bg_shadow_main_fit_content]: backgroundFitContent,
        [styles.bg_shadow_main__notification]: isNotification,
      })}
      style={{
        top: paddingTop || '0',
        zIndex: 1000 + order * 100,
      }}
    >
      <div
        id={styles.bg_content}
        className={classNames(
          'pos-f',
          position || 'pos-a-c-m',
          contentWidth,

          {
            'overlay-v3': isV3,
            [styles.bg_box_shadow]: withBoxShadow,
          },
          'disable-scroll',
        )}
      >
        {isFade === false ? children : <FadeInContainer>{children}</FadeInContainer>}
      </div>
      <div
        id={isNotification ? styles.bg_shadow__notification : styles.bg_shadow}
        className={classNames(styles.backdrop, {
          [styles.bg_transparent]: isBgTransparent,
          [styles.bg_dark]: !isBgTransparent,
          [styles.bg_blur_wheel]: blurBgWheel,
        })}
        onClick={() => closeBg()}
      />
    </div>
  );
};
export default OverlayFixedBg;
